<template>
  <div>
    <div style="padding:2px 5px">
      <van-search v-model="k" placeholder="请输入搜索关键词" shape="round"  show-action @search="onSearch">
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
    </div>
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;

import { Icon, Button, Search } from "vant";

export default {
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Search.name]: Search
  },

  data() {
    return {
      getInitUrl: root + "user/ershoufang",
      k: ""
    };
  },

  mounted() {},

  methods: {
    onSearch() {
      this.$emit("change", this.k);
    }
  }
};
</script>

<style scoped>
</style>>



